
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'
import ItemsSearchDialog from '../../components/Field/ItemsSearchDialog.vue'
import { cardPropertyObject } from './CardPropertyObject.js'
import RelationshipCardWrapper from './RelationshipCardWrapper.vue'

export default {
  name: 'CardPropertyObjectTable',
  extends: CardPropertyTable,
  mixins: [cardPropertyObject],
  data: function () {
    let componentProps = this.tabProp.componentProps
    if (!componentProps) {
      componentProps = {}
      this.$set(this.tabProp, 'componentProps', componentProps)
    }
    // Если колонка одна, то не отображаем заголовок и пэйджинацию
    if (!componentProps.columns || componentProps.columns.length <= 1) {
      this.$set(componentProps, 'rowsPerPage', 0)
      if (componentProps.hideHeader == null) {
        this.$set(componentProps, 'hideHeader', true)
      }
      if (componentProps.hideBottom == null) {
        this.$set(componentProps, 'hideBottom', true)
      }
      // componentProps.rowsPerPage = 0
      // componentProps.hideHeader = true
      // componentProps.hideBottom = true
    }

    return {
      selectFn: this.onShowSelectionDialog // @Override
    }
  },
  computed: {
    columns: function () {
      let columnsProps
      const columns = this.componentProps.columns
      if (columns && columns.length) {
        columnsProps = columns
      } else {
        columnsProps = [{ name: 'name', label: 'Название', type: 'string' }]

        const componentProps = this.tabProp.componentProps
        if (componentProps.showRelationship) {
          columnsProps.push({
            name: 'showRelationship',
            label: '',
            type: '_btn',
            sortable: false,
            componentProps: {
              tooltip: 'Открыть карточку связи',
              onClick: this.onShowRelationship,
              icon: 'mdi-card-bulleted-outline' // mdiApplicationCogOutline
            }
          })
          columnsProps.push({
            name: 'showObject',
            label: '',
            type: '_btn',
            sortable: false,
            componentProps: {
              tooltip: 'Открыть карточку объекта',
              onClick: (row, event) => this.showObjectCard(event, row),
              icon: 'mdi-text-box-outline'
            }
          })
        }
      }
      return columnsProps.map(o => this.getColumnConfig(o))
    },
    propertyRows: function () {
      if (this.object && this.tabProp) {
        const value = this.object[this.tabProp.key]
        if (value == null) {
          // !!! Преобразование вынесено в ObjectCard.setObject()
          // value = []
          // this.$set(this.object, this.tabProp.key, value)
          throw new Error(`Значение ссылочного параметра "${this.tabProp.key}" равно null`)
        }
        return value
      }
      return []
    }
  },
  methods: {
    // @Override
    onRowClick: function (event, row) {
      // иначе ссылки в ячейках таблицы не работают
      if (event.target.closest('a')) {
        return
      }

      const componentProps = this.tabProp.componentProps
      if (!componentProps.showRelationship) {
        this.showObjectCard(event, row)
      }
      this.$emit('row-click', {
        row,
        index: this.rows.indexOf(row),
        event
      })
    },
    showObjectCard: function (event, row) {
      if (this.hasAccessToOpenCard(row)) {
        this.$d_showObjectCard(row.id, row.type, event.ctrlKey)
      }
    },
    hasAccessToOpenCard: function (row) {
      // TODO type_open_access проверка доступа к типам объектов
      const propertyData = row
      const property = this.tabProp
      if (propertyData && property) {
        if (property.type === 'sysobject' || property.type === 'sysobjects') {
          return false
        }
        return this.$d_hasObjectCardAccess(propertyData.type)
      }
      return false
    },

    // @Override
    onDeleteRow: function (row) {
      const rows = this.object[this.tabProp.key]
      const index = rows.indexOf(row)
      if (index !== -1) {
        rows.splice(index, 1)
      }
    },

    onShowSelectionDialog: function () {
      this.$q.dialog({
        component: ItemsSearchDialog,
        parent: this,
        config: {
          headerLabel: this.componentProps.dialogLabel,
          value: this.object[this.tabProp.key],
          store: this.objectFieldConfig.store,
          multiple: true, // TODO this.multiple
          onApply: items => {
            this.object[this.tabProp.key] = items
          }
        }
      })
    },

    onShowRelationship: function (row, event) {
      if (this.hasAccessToOpenCard(row)) {
        const dialog = this.$d.dialog(this).show({
          maximizedOnNarrow: true,
          persistent: true,
          noWrap: true,
          contentWidth: 800,
          contentComponent: RelationshipCardWrapper,
          contentProps: {
            relationshipObjectId: this.object.id,
            propertyKey: this.tabProp.key,
            objectId: row.relId,
            closable: true
          },
          componentHandlers: {
            save: (saveData) => {
              if (saveData.reloadObject) {
                // TODO reloadObject ???
                // dialog.hide()
              }
            },
            close: () => {
              dialog.hide()
            }
          }
        })
      }
    }
  }
}
